module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.showSolid || _vm.showHollow) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['tag-item', 'tag-border', _vm.showHollow && 'tag-hollow'],
    style: (_vm._px2rem(_vm.tagTextStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "tag-text weex-el weex-text",
    style: ({
      color: _vm.fontColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.value))])]) : _vm._e(), _vm._v(" "), (_vm.showImage) ? _c('figure', {
    staticClass: "tag-image weex-el weex-image",
    style: ({
      width: _vm._px2rem(_vm.imgWidth + 'px', 75)
    }),
    attrs: {
      "src": _vm.img,
      "aria-hidden": true,
      "data-img-src": _vm.img,
      "weex-type": "image",
      "data-evt-load": ""
    },
    on: {
      "load": _vm.onLoad
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSpecial) ? _c('div', {
    staticClass: "tag-special tag-border weex-ct weex-div",
    style: ({
      borderColor: _vm.tagColor
    }),
    attrs: {
      "accessible": true,
      "aria-label": _vm.value,
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "tag-left weex-ct weex-div",
    style: ({
      backgroundColor: _vm.tagColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('figure', {
    staticClass: "left-image weex-el weex-image",
    attrs: {
      "src": _vm.specialIcon,
      "data-img-src": _vm.specialIcon,
      "weex-type": "image"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tag-text weex-el weex-text",
    style: ({
      color: _vm.fontColor
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.value))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-904d5398", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-904d5398","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-taged/index.vue
// module id = 644
// module chunks = 0 1